export const PROJECT_STAGE = 'beta';

export const GA_IDENTIFIER = 'UA-68105790-2';

export const SENTRY_DSN = 'https://288ba440f7b645b3967de69208e033e3:475acabe8ca24d6eb0c81097e959966d@sentry.io/113054';
export const SENTRY_AUTH_TOKEN = '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';

export const landingpage_url = 'https://1848.nl/';
export const app_url = 'https://app.1848.nl/';

export const staging_basic_auth = '';
